<template>
	<!-- 隐私协议弹窗 -->
	<el-dialog
		:visible.sync="show"
		:title="'VapeTM Application VapeTM EULA'"
		:show-close="false"
		:modal-append-to-body="false"
		:close-on-click-modal="false"
		:close-on-press-escape="false"
		top="5vh"
		width="800px">
		<div class="privacy-content">
			<body>
				<div>
					<p
						style="
							margin-top: 50px;
							margin-bottom: 0pt;
							text-align: center;
							font-size: 18pt;
						">
						<span style="font-family: Times; font-weight: bold">
							Dedicated Protocol Placeholder
						</span>
					</p>
					<p
						style="
							margin-top: 30px;
							margin-bottom: 0pt;
							text-align: center;
							font-size: 14pt;
						">
						<span style="font-family: Times">
							[Special Protocol Content Will Be Inserted Here]
						</span>
					</p>
				</div>
			</body>
		</div>
		<span
			slot="footer"
			class="dialog-footer"
			style="
				display: flex;
				justify-content: space-between;
				align-items: center;
			">
			<el-checkbox v-model="canClick">
				I have read and agree to the terms of the above agreement.
			</el-checkbox>
			<el-button
				:loading="loadingAgree"
				:disabled="!canClick"
				type="primary"
				size="small"
				@click="agreePrivacy"
				>Okay</el-button
			>
		</span>
	</el-dialog>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import eventBus from "@/utils/eventBus";

export default {
	props: {
		show: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		//这里存放数据",
		return {
			loadingAgree: false,
			canClick: false,
		};
	},
	//监听属性 类似于data概念",
	computed: {},
	//监控data中的数据变化",
	watch: {},
	//方法集合",
	methods: {
		agreePrivacy() {
			this.loadingAgree = true;
			//调用接口 已阅读
			this.$api
				.request(this.$url.PrivacyAgreement.agree, this.$method.post, {})
				.then(() => {
					// 用户同意隐私协议后，关闭弹窗并记录状态
					this.loadingAgree = false;
					this.$emit("close");
                    eventBus.emit("openPasswordDialog");
				});
		},
    },
};
</script>

<style lang="scss" scoped>
.privacy-content {
	height: 70vh;
	overflow-y: scroll;

	padding: 0 10px;
}
</style>
